module.exports = __webpack_public_path__ + "static/lato-v14-latin-300-bbbd26aeee9c5b967e35933bce02d358.woff2";